import Anchor from 'components/typography/anchor';
import { DATA_TYPES } from 'siteconfig';
import { CampaignTypeDriveList } from 'utilities/propTypes';

const Drive = ({ drive }) => {
  const basePath = DATA_TYPES.DRIVE.basePath;
  const shareCode = drive.shareCode;
  const campaignSignCount = drive.signCount.toLocaleString();
  const campaignSubject = drive.subject;
  const countLabel = 'Pledges';
  const trigger = 'pledge';

  return (
    <div className="text-left">
      <Anchor
        className="animate-fadeIn relative m-4 mx-auto flex flex-row flex-wrap gap-2 gap-x-4 rounded p-4 text-gray-800 shadow-md hover:text-gray-800 dark:text-gray-100 dark:hover:border-blue-500 dark:hover:text-gray-100"
        href={`/${basePath}/${shareCode}`}
      >
        <div className="flex-basis-[375px] flex flex-grow flex-col gap-1">
          <p className="m-0 text-base font-[650] -tracking-[0.01em] tracking-tight text-gray-800 dark:text-gray-100">
            {campaignSubject}
          </p>

          <p className="m-0">
            To {trigger} {shareCode}
          </p>
        </div>

        <div className="flex gap-4 text-base leading-normal">
          <div>
            <p className="font-bold">{campaignSignCount}</p>
            <p className="text-xs font-semibold tracking-wider uppercase">
              {countLabel}
            </p>
          </div>
        </div>
      </Anchor>
    </div>
  );
};

Drive.propTypes = {
  drive: CampaignTypeDriveList.isRequired,
};

export { Drive };
